import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Modal from '@mui/material/Modal';
import { DataGrid } from '@mui/x-data-grid';
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Notification from '../../../../../pages/General/Notification'
import { fetchWebhookDetail, storeWebhook, destoryWebhook, resetConfigureStateDetails } from './webhookSlice';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 540 },
    bgcolor: 'background.paper',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    borderRadius: '16px',
    overflow: 'hidden',
    outline: 'none'
};

const deleteModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400 },
    bgcolor: 'background.paper',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    borderRadius: '16px',
    p: 3.5,
    outline: 'none'
};

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    boxShadow: 'none',
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    height: '100%'
}));

// Standard corporate outliner dictionary configuring premium input layouts
const enterpriseInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        '& fieldset': { borderColor: '#E2E8F0' },
        '&:hover fieldset': { borderColor: '#CBD5E1' },
        '&.Mui-focused fieldset': { 
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-root': {
        color: '#64748B',
        fontWeight: 500,
        '&.Mui-focused': { color: '#1976d2' }
    }
};

const Modalpopup = ({ modalVisible, setModalVisible, formValues }) => {
    const dispatch = useDispatch();
    const webhook = useSelector(state => state.webhook);
    const [webhookdomain, setWebhookdomain] = useState('');
    const [webhookstatus, setWebhookstatus] = useState('');
    const [eventname, setEventname] = useState('');
    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(true);
    useEffect(() => {
        if (formValues && Object.keys(formValues).length !== 0) {
            setEventname(formValues && formValues.event)
            setWebhookstatus(formValues && formValues.enable)
            setWebhookdomain(formValues && formValues.webhook_url)
        }
    }, [formValues])

    const onModalClose = () => {
        setModalVisible(false)
    }
    const checkUpdateFormHasValues = () => {
        let updatedisableButton = true
        if (webhookdomain !== '') {
            updatedisableButton = false
        }
        return updatedisableButton
    }
    useEffect(() => {
        setUpdateButtonDisabled(checkUpdateFormHasValues())
    }, [webhookdomain])

    const modalhandleSubmit = e => {
        const values = {
            'event': eventname,
            'enable': webhookstatus.toString(),
            'webhook_url': webhookdomain,
            "_method": 'put'
        }
        dispatch(storeWebhook(values))
    }

    return (
        <Modal
            open={modalVisible}
            onClose={onModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
        >
            <Box sx={style}>
                <Card sx={{ border: 'none', boxShadow: 'none' }} className="sc--cardhead--details">
                    <CardHeader 
                        title={
                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                {`Update Hook - ${formValues && formValues.event}`}
                            </Typography>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 3.5 }}>
                        <Stack spacing={2.5}>
                            <Box className="sc--form--center">
                                <TextField
                                    label="Webhook Url"
                                    name="webhook_url"
                                    size="small"
                                    defaultValue={formValues && formValues.webhook_url}
                                    onInput={e => setWebhookdomain(e.target.value)}
                                    variant="outlined"
                                    sx={enterpriseInputStyles}
                                />
                            </Box>
                            
                            <Box sx={{ p: 2, backgroundColor: '#F8FAFC', border: '1px solid #F1F5F9', borderRadius: '10px' }}>
                                <FormGroup sx={{ width: "100%" }}>
                                    <FormControlLabel
                                        control={<Switch
                                            defaultChecked={formValues && formValues.enable}
                                            onChange={e => setWebhookstatus(e.target.checked)} name="enable"
                                            color="primary"
                                        />}
                                        label={<Typography sx={{ fontSize: '14px', fontWeight: 600, color: '#334155' }}>Active Status</Typography>}
                                    />
                                </FormGroup>
                            </Box>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, pt: 1 }}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={onModalClose}
                                    sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, px: 3, height: '36px', borderColor: '#CBD5E1', color: '#475569', '&:hover': { backgroundColor: '#F8FAFC', borderColor: '#94A3B8' } }}
                                >
                                    Cancel
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    size="small"
                                    onClick={modalhandleSubmit}
                                    loading={webhook && webhook.loading}
                                    disabled={updateButtonDisabled}
                                    sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, px: 3, height: '36px', boxShadow: 'none', '&:hover': { boxShadow: 'none' } }}
                                >
                                    Update
                                </LoadingButton>
                            </Box>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>
        </Modal >
    )
}

const WebhookIntegration = ({ storeName, platformName, storeParam, storeId }) => {

    const dispatch = useDispatch();
    const webhook = useSelector(state => state.webhook);
    const webhookdata = useSelector(state => state.webhook.webhook);

    const [event, setEvent] = useState('');
    const [webhookurl, setWebhookurl] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [deleteid, setDeleteId] = React.useState("");

    let events = {
        "Order Received": false,
        "Fulfilled": false,
        "Picked Up": false,
        "In Transit": false,
        "Shipment On Hold": false,
        "Out For Delivery": false,
        "Delivered": false,
        "Exception": false,
        "Delivery Attempt Failure": false,
        "Returns": false,
        "Lost": false,
        "Damage": false,
    }
    let options = [];
    for (const [key, value] of Object.entries(webhookdata)) {
        console.log(value)
        if (events[value.event] !== undefined && key !== "") {
            events[value.event] = true;
        }
    }
    for (const [eventKey, eventValue] of Object.entries(events)) {
        options.push(
            <MenuItem key={eventKey} value={eventKey} disabled={eventValue} sx={{ fontSize: '13.5px', py: 1 }}>
                {eventKey}
            </MenuItem>
        );
    }
    console.log(events)
    const onDelete = (item) => {
        setDeleteId(item)
        setDeleteModalopen(true);
    }

    const deleteEvent = (item) => {
        dispatch(destoryWebhook(item))
        setDeleteModalopen(false)
    }

    const handleSubmit = () => {
        if (event != '' && webhookurl != '') {
            const values = { 'event': event, 'webhook_url': webhookurl, "_method": 'put' }
            dispatch(storeWebhook(values))
        }
    }
    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };
    const checkFormHasValues = () => {
        let disableButton = true
        if (event !== '' && webhookurl !== '') {
            disableButton = false
        }
        return disableButton
    }
    useEffect(() => {
        setSaveButtonDisabled(checkFormHasValues())
    }, [event])
    useEffect(() => {
        setSaveButtonDisabled(checkFormHasValues())
    }, [webhookurl])
    const columns = [
        { field: 'event', headerName: 'Event Type', flex: 1, renderCell: (params) => <Typography variant="body2" sx={{ fontWeight: 600, color: '#1E293B' }}>{params.row.event}</Typography> },
        {
            field: 'notification_type',
            headerName: 'Status',
            flex: 0.6,
            renderCell: (params) => {
                return (
                    <Switch
                        defaultChecked={params.row.enable}
                        name="is_update_shipment"
                        color="primary"
                        size="small"
                    />
                )
            }
        },
        {
            field: 'webhook_url',
            headerName: 'Webhook URL',
            flex: 1.5,
            renderCell: (params) => {
                return <Typography variant="body2" sx={{ color: '#475569', fontFamily: 'monospace', fontSize: '12.5px' }}>{params.row.webhook_url}</Typography>
            }
        },
        {
            field: 'ACTIONS',
            headerName: 'Actions',
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                        <IconButton 
                            size="small"
                            onClick={() => {
                                setSelectedItem(params.row);
                                setModalVisible(true)
                            }}
                            sx={{ color: '#0284c7', border: '1px solid #E2E8F0', borderRadius: '8px', p: 0.5, '&:hover': { backgroundColor: '#F0F9FF', borderColor: '#bae6fd' } }}
                        >
                            <EditIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                        <IconButton
                            size="small"
                            onClick={() => {
                                onDelete(params.row.event)
                            }}
                            sx={{ color: '#EF4444', border: '1px solid #E2E8F0', borderRadius: '8px', p: 0.5, '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' } }}
                        >
                            <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                    </Box>
                )
            },
            flex: 0.8
        }
    ]
    useEffect(() => {
        dispatch(fetchWebhookDetail());
    }, [dispatch])
    console.log(options)
    return (
        <>
            {(webhook && webhook.notification && webhook.notification.showMessage) &&
                <Notification
                    is_open={webhook.notification.showMessage}
                    messageType={webhook.notification.messageType}
                    messages={webhook.notification.messageContent}
                    handleClose={() => dispatch(resetConfigureStateDetails())}
                />}
            <Modalpopup
                modalVisible={modalVisible}
                setModalVisible={setModalVisible}
                formValues={selectedItem}
            />
            <Modal
                open={deleteModalopen}
                onClose={deleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                closeAfterTransition
            >
                <Box sx={deleteModalStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 700, color: '#0F172A', fontSize: '16px', mb: 1 }}>
                        Confirm Deletion
                    </Typography>
                    <Typography id="modal-modal-description" variant="body2" sx={{ color: '#475569', mb: 3, lineHeight: 1.5 }}>
                        Are you sure you want to delete the <strong>{deleteid}</strong> event? This action cannot be reverted.
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={deleteModalClose}
                            sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 600, borderColor: '#CBD5E1', color: '#475569', '&:hover': { backgroundColor: '#F8FAFC', borderColor: '#94A3B8' } }}
                        >
                            No, Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={(event) => {
                                deleteEvent(deleteid)
                            }}
                            sx={{ textTransform: 'none', borderRadius: '8px', fontWeight: 700, boxShadow: 'none', '&:hover': { boxShadow: 'none', backgroundColor: '#DC2626' } }}
                        >
                            Yes, Delete
                        </Button>
                    </Box>
                </Box>
            </Modal>
            
            <Grid container spacing={0} sx={{ mb: 4 }}>
                <Grid item xs={12}>
                    <Card 
                        sx={{ 
                            backgroundColor: '#FFFFFF',
                            border: '1px solid #E2E8F0',
                            borderRadius: '16px',
                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                            overflow: 'hidden'
                        }} 
                        className="sc--cardhead--details"
                    >
                        <Box style={{ width: '100%', background: '#fff' }}>
                            <CardHeader 
                                title={
                                    <Typography variant="h6" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                                        Add Webhook Target
                                    </Typography>
                                } 
                                sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                            />
                            <Divider sx={{ borderColor: '#E2E8F0' }} />
                            <CardContent sx={{ p: 4 }}>
                                <Box sx={{ width: '100%', maxWidth: '520px', mx: 'auto' }}>
                                    <Stack spacing={3}>
                                        <Box className="sc--form--center">
                                            <FormControl fullWidth variant="outlined" size="small">
                                                <InputLabel id="webhook-event-select-label" sx={enterpriseInputStyles['& .MuiInputLabel-root']}>Select Event Type</InputLabel>
                                                <Select
                                                    labelId="webhook-event-select-label"
                                                    id="demo-simple-select-standard"
                                                    name="events"
                                                    value={event}
                                                    onChange={(e) => {
                                                        setEvent(e.target.value)
                                                    }}
                                                    label="Select Event Type"
                                                    sx={enterpriseInputStyles['& .MuiOutlinedInput-root']}
                                                >
                                                    {options}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        
                                        <Box className="sc--form--center">
                                            <TextField
                                                label="Webhook Target URL"
                                                name="webhook_url"
                                                size="small"
                                                onInput={e => setWebhookurl(e.target.value)}
                                                variant="outlined"
                                                type="url"
                                                placeholder="https://api.yourdomain.com/webhook"
                                                sx={enterpriseInputStyles}
                                            />
                                        </Box>
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderTop: '1px solid #F1F5F9', pt: 2.5 }}>
                                            <LoadingButton
                                                variant="contained"
                                                onClick={handleSubmit}
                                                loading={webhook && webhook.loading}
                                                disabled={saveButtonDisabled}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '8px',
                                                    fontWeight: 700,
                                                    fontSize: '13.5px',
                                                    height: '38px',
                                                    px: 4,
                                                    boxShadow: 'none',
                                                    '&:hover': { boxShadow: 'none' }
                                                }}
                                            >
                                                Save Endpoint
                                            </LoadingButton>
                                        </Box>
                                    </Stack>
                                </Box>
                            </CardContent>
                        </Box>
                    </Card>
                </Grid>
            </Grid>

            {/* Registered Data Logs Table Layer Registry */}
            <Card 
                sx={{ 
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden'
                }} 
                className="sc--cardhead--details"
            >
                <Box style={{ width: '100%', background: '#fff' }}>
                    <Box sx={{ maxWidth: '100%' }}>
                        <DataGrid
                            getRowId={(row) => row.event}
                            disableRowSelectionOnClick
                            rows={webhook && webhook.webhook || []}
                            columns={columns}
                            autoHeight
                            hideFooter
                            loading={webhook && webhook.loading}
                            sx={{
                                border: 'none',
                                backgroundColor: '#FFFFFF',
                                '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC' },
                                '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', borderBottom: '1px solid #E2E8F0', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiDataGrid-row': { borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '14px', '&:focus, &:focus-within': { outline: 'none' } },
                                '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                            }}
                            slots={{
                                loadingOverlay: LinearProgress,
                            }}
                        />
                    </Box>
                </Box>
            </Card>
        </>
    )
}

export default WebhookIntegration;